export const LOGO_URL = "https://customer-assets.emergentagent.com/job_kotzinons-studio/artifacts/h1vn06yu_logo-kotzinons.png";

// Cinematic hero art
export const SPACESHIP_HERO_URL = "https://customer-assets.emergentagent.com/job_kotzinons-studio/artifacts/e5uk8vdi_WhatsApp%20Image%202026-06-24%20at%2015.58.59.jpeg";
export const GROUP_TRIO_URL = "https://customer-assets.emergentagent.com/job_kotzinons-studio/artifacts/5lu5oxb2_WhatsApp%20Image%202026-06-24%20at%2015.59.00.jpeg";
export const KOTZINENA_HERO_URL = "https://customer-assets.emergentagent.com/job_kotzinons-studio/artifacts/t0mvwdio_WhatsApp%20Image%202026-06-24%20at%2015.58.59%20%281%29.jpeg";
export const WARROOM_ALERT_URL = "https://customer-assets.emergentagent.com/job_kotzinons-studio/artifacts/a74ohgnv_WhatsApp%20Image%202026-07-03%20at%2015.42.18.jpeg";
export const GOLIATH_URL = "https://customer-assets.emergentagent.com/job_kotzinons-studio/artifacts/b9fnau5h_WhatsApp%20Image%202026-06-27%20at%2011.06.48.jpeg";

// Storybook — the real published book (Uri Menashe Eini, © 2018, Niv Books)
export const BOOK_FRONT_URL = "/kotzinons-book-front.jpg";
export const BOOK_BACK_URL = "/kotzinons-book-back.jpg";
export const BOOK_SPREAD_URL = "/kotzinons-book-spread.jpg";
export const BOOK_META = {
  titleEn: "The Adventure of Moya and Kotzinon",
  titleHe: "\u05D4\u05B7\u05D4\u05B7\u05E8\u05B0\u05E4\u05B7\u05EA\u05B0\u05E7\u05B8\u05D4 \u05E9\u05B6\u05C1\u05DC \u05DE\u05D5\u05B9\u05D9\u05B8\u05D4 \u05D5\u05B0\u05E7\u05D5\u05B9\u05E6\u05B4\u05D9\u05E0\u05D5\u05B9\u05DF",
  series: "The Kotzinons — First Book",
  author: "Uri Menashe Eini",
  copyright: "\u00A9 2018",
  publisher: "Niv Books (Sifrei Niv)",
  publisherUrl: "https://bookpublisher.co.il",
  language: "Hebrew (published in Israel)",
};

// Legacy alias kept so any older import path still resolves
export const RUBY_HERO_URL = KOTZINENA_HERO_URL;

// Backwards-compatible legacy alias (some team-avatar / footer references use "goldon")
export const INVESTOR_EMAIL = "uriemi@kotzinons.com";

export const COLOR_MAP = {
  red: {
    hsl: "var(--kotz-red)",
    bg: "bg-[hsl(var(--kotz-red))]",
    bgSoft: "bg-[hsl(var(--kotz-red))]/15",
    text: "text-[hsl(var(--kotz-red))]",
    border: "border-[hsl(var(--kotz-red))]/40",
    ring: "ring-2 ring-[hsl(var(--kotz-red))]/40",
    glow: "ring-spike-red",
    label: "Crimson Steel",
  },
  blue: {
    hsl: "var(--kotz-blue)",
    bg: "bg-[hsl(var(--kotz-blue))]",
    bgSoft: "bg-[hsl(var(--kotz-blue))]/15",
    text: "text-[hsl(var(--kotz-blue))]",
    border: "border-[hsl(var(--kotz-blue))]/40",
    ring: "ring-2 ring-[hsl(var(--kotz-blue))]/40",
    glow: "ring-spike-blue",
    label: "Cobalt Storm",
  },
  gold: {
    hsl: "var(--kotz-gold)",
    bg: "bg-[hsl(var(--kotz-gold))]",
    bgSoft: "bg-[hsl(var(--kotz-gold))]/20",
    text: "text-[hsl(var(--kotz-gold))]",
    border: "border-[hsl(var(--kotz-gold))]/50",
    ring: "ring-2 ring-[hsl(var(--kotz-gold))]/50",
    glow: "ring-spike-gold",
    label: "Crystal Cell",
  },
  green: {
    hsl: "var(--kotz-green)",
    bg: "bg-[hsl(var(--kotz-green))]",
    bgSoft: "bg-[hsl(var(--kotz-green))]/15",
    text: "text-[hsl(var(--kotz-green))]",
    border: "border-[hsl(var(--kotz-green))]/40",
    ring: "ring-2 ring-[hsl(var(--kotz-green))]/40",
    glow: "ring-spike-green",
    label: "Verdant Vine",
  },
  purple: {
    hsl: "var(--kotz-purple)",
    bg: "bg-[hsl(var(--kotz-purple))]",
    bgSoft: "bg-[hsl(var(--kotz-purple))]/15",
    text: "text-[hsl(var(--kotz-purple))]",
    border: "border-[hsl(var(--kotz-purple))]/40",
    ring: "ring-2 ring-[hsl(var(--kotz-purple))]/40",
    glow: "ring-spike-purple",
    label: "Nightmare Violet",
  },
};

export const NAV_LINKS = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/characters", label: "Characters", testid: "nav-characters" },
  { to: "/gallery", label: "Gallery", testid: "nav-gallery" },
  { to: "/animations", label: "Animations", testid: "nav-animations" },
  { to: "/storybook", label: "Storybook", testid: "nav-storybook" },
  { to: "/about", label: "Our Story", testid: "nav-about" },
  { to: "/team", label: "Team", testid: "nav-team" },
  { to: "/invest", label: "Invest", testid: "nav-invest" },
  { to: "/contact", label: "Contact", testid: "nav-contact" },
];

export const GALLERY_CATEGORIES = [
  { value: "all", label: "All" },
  { value: "digital-renders", label: "Digital Renders" },
  { value: "concept-art", label: "Concept Art" },
];

export const INQUIRY_TYPES = [
  { value: "general", label: "General Inquiry" },
  { value: "partnership", label: "Partnership" },
  { value: "licensing", label: "Licensing" },
  { value: "investment", label: "Investment" },
  { value: "press", label: "Press / Media" },
  { value: "fan", label: "Fan Mail" },
];
